import { reactive } from 'vue';

import type { BaseOptionModel } from '@/models';
import type { Flow, State } from '@/types'

export function useExchangeItem(defaultSelected: BaseOptionModel, defaultFlow: Flow, initialAmount = '') {
    const state = reactive({
        selected: defaultSelected,
        flow: defaultFlow,
        amount: initialAmount,
        equivalentAmount: '',
        showDropDown: false,
        error: null,
    }) as State;

    return {
        state,
    };
}
